import moment from 'moment'

const store = {
    state: {
        loggedIn: false,
        username: null,
        isAdmin: false,
        canReview: false,
        userId: null,
        role: null,
        token: null,
        expiration: null
    },
    init(result) {
        result.expiration = moment().add('1', 'hour').toDate();
        localStorage.setItem('userInfo', JSON.stringify(result));
        this.loadFromLocalStorage();
    },
    loadFromLocalStorage(){
        let userInfo = localStorage.getItem('userInfo') || null;
        let now = moment();
        if(userInfo) {
            userInfo = JSON.parse(userInfo);
            if(!userInfo.expiration) {
                localStorage.clear();
                return;
            }
            
            let expiration = moment(userInfo.expiration);
            if(now.diff(expiration, 'minutes') > 1) {
                localStorage.clear();
                return;
            }
            
            Object.keys(this.state).forEach(key => {
                this.state[key] = userInfo[key];
            });
            this.state.isAdmin = this.state.role == 'admin';
            this.state.loggedIn = userInfo.auth;
            this.state.canReview = this.state.role == 'admin' || this.state.role == 'reviewer';
            this.expiration = userInfo.expiration;
        }
    },
    clear() {
        localStorage.clear();
        this.state.loggedIn = false;
        this.state.username = null;
        this.state.isAdmin = false;
        this.state.canReview = false;
        this.state.userId = null;
        this.state.role = null;
        this.state.token = null;
        this.expiration = null;
    }
}

export { store }


// WEBPACK FOOTER //
// ./src/framework/store.js